<template>
  <a-modal
    v-model="visible"
    :title="$t('device_control_remote_title')"
    :maskClosable="false"
    width="80%"
    forceRender
    destroyOnClose
    :bodyStyle="{ padding: 0 }"
    centered
    :afterClose="close"
  >
    <div class="device-control">
      <Loading :show="true" v-if="loading" style="margin:50px auto;" />
      <div v-else class="device-control-selection">
        <!-- 选择设备 -->
        <div class="device-box">
          <!-- <div class="device-box-title">
            {{ $t('device_form_select_device') }}:
          </div> -->
          <div class="device-box-content device-config">
            <div class="device-selected">
              <a-tag
                :closable="
                  item.active && !item.close && !(formLoading || checkLoading) ? true : false
                "
                :class="item.active ? '' : 'diabled'"
                @close="selectDeviceDelete(item.key)"
                v-for="item in deviceListSelected"
                :key="item.key"
              >
                <a-tooltip
                  :title="
                    item.ctrl && item.ctrl.devStatus !== 2
                      ? exeResultError[item.ctrl.devStatus] || ''
                      : ''
                  "
                >
                  <div>{{ item.name }}</div>
                  <!-- 多个设备的时候才在设备上显示状态 -->
                  <!-- 控制的5种执行状态: 1表示pending，2表示成功，3表示失败，4表示超时，5表示离线 -->
                  <div class="g-refresh-status" v-if="isFinish">
                    <Icon
                      type="status_ok"
                      class="success"
                      v-if="item.ctrl && item.ctrl.devStatus === 2"
                    />
                    <Icon
                      type="status_error"
                      class="error"
                      v-if="item.ctrl && item.ctrl.devStatus !== 2"
                    />
                  </div>
                </a-tooltip>
              </a-tag>
            </div>
            <div class="device-selected-action">
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="willbeSelected"
                :placeholder="$t('device_form_select_device')"
                show-search
                allowClear
                style="width:300px;"
                :disabled="formLoading || checkLoading"
                :filter-option="
                  (input, option) => {
                    return (
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }
                "
              >
                <a-select-option
                  :value="device.key"
                  v-for="device in deviceList"
                  :key="device.key"
                  :disabled="device.disabled"
                >
                  {{ device.name }}
                </a-select-option>
              </a-select>

              <a-button
                type="primary"
                icon="plus"
                @click="selectDeviceConfirm"
                style="margin-left:10px;"
              >
                {{ $t('com_btn_add_device') }}
              </a-button>
            </div>
            <p style="color:#ec407a;padding:10px 0 5px 5px;margin:0;">
              {{ $t('device_control_remote_tip') }}
            </p>
          </div>
        </div>

        <div class="device-control-list">
          <a-form-model :model="form" :rules="controlRules" ref="formElement">
            <!-- 控制类型 -->
            <a-form-model-item
              :label="$t('device_control_type')"
              prop="ctrlId"
              style="margin-bottom:0"
            >
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="form.ctrlId"
                :placeholder="$t('device_form_select_type')"
                show-search
                allowClear
                style="width:300px;"
                @change="typeChange"
                :disabled="formLoading || checkLoading"
                :filter-option="
                  (input, option) => {
                    return (
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }
                "
              >
                <a-select-option
                  :value="control.id"
                  v-for="control in controlList"
                  :key="control.id"
                >
                  {{ control.cmdName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <!-- Update plc的参数文件名称的选择 -->
            <a-form-model-item
              :label="$t('device_PLC_type')"
              prop="plcType"
              style="margin-bottom:0"
              v-if="currentControl && currentControl.protoEventType === 10"
            >
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="form.plcType"
                :placeholder="$t('device_form_select_type')"
                show-search
                allowClear
                style="width:300px;"
                :disabled="formLoading || checkLoading"
              >
                <a-select-option
                  v-for="option in plcOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <!-- 参数1 -->
            <div class="device-control-param1">
              <a-form-model-item
                :label="currentControl.param1"
                prop="param1"
                style="margin-bottom:0;"
                v-if="
                  currentControl && currentControl.param1 && currentControl.protoEventType !== 10
                "
              >
                <a-textarea
                  v-model="form.param1"
                  :placeholder="$t('device_form_param1')"
                  :rows="3"
                  allowClear
                  :disabled="formLoading || checkLoading"
                />
              </a-form-model-item>

              <!-- 参数2 -->
              <a-form-model-item
                :label="currentControl.param2"
                prop="param2"
                style="margin-bottom:0;"
                v-if="currentControl && currentControl.param2"
              >
                <a-textarea
                  v-model="form.param2"
                  :placeholder="$t('device_form_param2')"
                  :rows="3"
                  allowClear
                  :disabled="formLoading || checkLoading"
                />
              </a-form-model-item>
              <!-- FTP -->
              <a-button
                type="primary"
                v-if="
                  httpSupport &&
                    currentControl &&
                    currentControl.param1 &&
                    ftpTypeForUpgrade.includes(currentControl.protoEventType)
                "
                @click="selectFTP"
              >
                {{ $t('device_form_param1_ftp') }}
              </a-button>
            </div>
          </a-form-model>
          <!-- 错误描述 -->
          <div class="form-error-text">
            <Icon type="error" v-if="formError" />
            <p>{{ formError }}</p>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div v-if="!loading">
        <a-button @click="close" style="margin-right:5px;" v-if="isFinish">
          <!-- 成功时显示成功图标 -->
          <span class="g-refresh-status" style="position:relative;top:3px;">
            <Icon type="status_ok" class="success" />
          </span>
          <span>
            {{ $t('com_btn_finish') }}
          </span>
        </a-button>

        <a-button
          @click="close"
          style="margin-right:5px;"
          v-if="!(formLoading || checkLoading) && !isFinish"
          size="large"
        >
          {{ $t('com_btn_cancel') }}
        </a-button>

        <a-button
          type="primary"
          @click.prevent="onControlSubmit"
          :loading="formLoading || checkLoading"
          :disabled="formLoading || checkLoading"
          size="large"
        >
          {{ $t('com_btn_excute') }}
        </a-button>
      </div>
    </template>

    <AttachmentSelect
      v-if="attachmentVisible"
      :visible="attachmentVisible"
      :shortUrl="shortUrl"
      :uploadBucket="uploadBucket"
      :attachType="attachType"
      @cancel="
        () => {
          attachmentVisible = false;
        }
      "
      @ok="attachmentSelected"
    />
  </a-modal>
</template>
<script>
import * as ModelAPI from '@/api/system/model';
import * as API from '@/api/device';
import AttachmentSelect from '@/components/AttachmentSelect';
import { firmwareBucket } from '@/config/oss';

export default {
  components: {
    AttachmentSelect,
  },
  props: {
    device: {
      type: Object,
      default: null,
    },
    httpSupport: {
      type: Number,
      default: null,
    },
    configList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    form: {
      handler(_val) {
        this.formError = '';
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      visible: false,
      loading: false,

      willbeSelected: undefined,

      controlList: [],
      currentControl: null,

      // form
      form: {
        ctrlId: undefined,
        plcType: undefined,
        param1: undefined,
        param2: undefined,
      },
      formError: '',
      controlRules: {
        ctrlId: [
          {
            required: true,
            message: this.$t('device_control_form_ctrlid_error'),
            trigger: 'change',
          },
        ],
      },

      deviceList: [],
      deviceListSelected: [],
      formLoading: false,
      // 检查设备执行状态
      checkLoading: false,

      // 是否结束
      isFinish: false,

      // 轮询timer
      excuteTimer: null,

      // 执行结果的提示
      exeResultError: this.$t('device_control_excute_result_error_list'),

      // 显示附件选择框
      attachmentVisible: false,
      shortUrl: false,
      // 需要显示FTP的类型值，不是id, 是protoEventType
      // 5-> 从FTP附件/升级软件
      // 10-> Update PLC FW thru FTP
      ftpTypeForUpgrade: [5, 10],

      // 默认FTP值给第一个参数
      ftpParams: 'param1',
      uploadBucket: '',
      firmwareBucket: firmwareBucket,
      attachType: undefined,
      plcOptions: [
        { label: 'IMPU2', value: 1 },
        { label: 'IMPU3', value: 2 },
        { label: 'PSD', value: 3 },
      ],
    };
  },
  beforeDestroy() {
    this.clearExcuteTimer();
  },
  methods: {
    // 获取表单数据
    getData() {
      const _list = [this.getModelControlList(), this.getSameDeviceList()];

      Promise.all(_list).finally(() => {
        this.loading = false;
      });
    },

    clearExcuteTimer() {
      if (this.excuteTimer) {
        clearTimeout(this.excuteTimer);
      }
    },

    // 显示
    show(_device, _type) {
      this.visible = true;
      this.getData();
    },

    // 获取当前Model 参数列表
    getModelControlList() {
      this.loading = true;
      return ModelAPI.DeviceModelControlList({
        devModelId: this.device.model.devModelId,
      }).then(res => {
        if (res.code === 0) {
          this.controlList = res.data || [];

          // 在获取到 controlList 后，执行过滤逻辑
          this.filterControlList();
        }
      });
    },
    // 过滤 controlList
    filterControlList() {
      // 查找符合条件的 configList 项
      const targetConfig = this.configList.find(
        item =>
          (item.name === 'PLC Board Type' || item.name === 'PLC 板类型') &&
          item.rvalue !== undefined
      );

      // 如果没有找到符合条件的项，直接过滤掉 "Update PLC FW thru FTP" 项
      if (!targetConfig) {
        this.controlList = this.controlList.filter(control => control.protoEventType !== 10);
      }

      // 将 dataRange 按行分割
      const dataRangeArray = targetConfig.dataRange.split('\n');
      // 获取 rvalue 对应的行（字符串转10进制）
      const rvalueIndex = parseInt(targetConfig.rvalue, 10);
      // 获取该行的数据
      const targetLine = dataRangeArray[rvalueIndex];
      // 如果该行的数据为空，直接过滤掉 "Update PLC FW thru FTP" 项
      if (!targetLine) {
        this.controlList = this.controlList.filter(control => control.protoEventType !== 10);
      }

      // 将该行按 "|" 分割，获取实际值和索引值
      const [paramValue] = targetLine.split('|');
      // 如果 paramValue 不是 "IMPU2"，则过滤掉 "Update PLC FW thru FTP" 项
      if (paramValue !== 'IMPU2') {
        this.controlList = this.controlList.filter(control => control.protoEventType !== 10);
      }
    },

    // 查询同类型的设备
    getSameDeviceList() {
      const params = {
        devId: this.device.info.devId,
      };
      return API.DeviceInSameSite(params).then(res => {
        if (res.code === 0) {
          // 左边数据
          this.deviceList = [];

          // 筛选已经选择的设备
          this.deviceListSelected = [];
          res.data.forEach(item => {
            if (item.devId === this.device.info.devId) {
              this.deviceListSelected.push({
                key: item.devId,
                name: item.name,
                active: false,
              });
            } else {
              this.deviceList.push({
                key: item.devId,
                name: item.name,
                active: true,
              });
            }
          });
        }
      });
    },

    typeChange(value) {
      this.formError = '';
      this.currentControl = this.controlList.find(item => item.id === value);
      this.form.plcType = undefined; // 重置 Update plc 参数文件名称选择
      this.form.param1 = undefined;
      this.form.param2 = undefined;

      // 固件FTP时，使用短URL
      this.shortUrl = false;
      this.uploadBucket = undefined;
      this.attachType = undefined;
      // 11-> 从FTP附件/升级软件
      // 55-> Update PLC FW thru FTP
      if (this.ftpTypeForUpgrade.includes(this.currentControl.protoEventType)) {
        // 升级的命令，使用短URL
        // this.shortUrl = true;
        this.uploadBucket = this.firmwareBucket;
        // 附件用途类型，用于特定业务过滤使用；默认不传或者传null表示所有，其他为 0-普通附件;1-固件附件;2:日志附件;3-问题附件
        this.attachType = 1;
      }

      // 默认FTP值给第一个参数
      this.ftpParams = 'param1';

      // Update PLC FW thru FTP时，FTP URL给第二个参数
      if (this.currentControl.protoEventType === 10) {
        this.ftpParams = 'param2';
      }
    },

    // 禁用或开启已选设备的删除操作
    deviceListSelectedAction(close) {
      this.deviceListSelected.forEach(item => {
        item.close = close ? false : true;
      });
    },

    // 检查设备状态
    checkDeviceStatus() {
      const devIdList = this.deviceListSelected.map(item => item.key);
      const params = {
        devIds: devIdList.join(','),
      };
      this.checkLoading = true;
      this.formError = '';
      return API.DevicesStatusCheck(params)
        .then(res => {
          if (res.code === 0) {
            const data = res.data;
            // 是否全部设备空闲
            let hasBusy = false;
            data.some(item => {
              if (item.ctrlStatus !== 0) {
                hasBusy = true;
                return true;
              }
              return false;
            });

            if (hasBusy) {
              this.formError =
                data.length > 1 ? this.$t('device_msg_some_busy') : this.$t('device_msg_busy');
              this.checkLoading = false;
              return false;
            }
            return true;
          } else {
            // 报错
            this.checkLoading = false;
            this.formLoading = false;
            this.formError = res.message;
            this.isFinish = false;
            this.deviceListSelectedAction(false);
            return false;
          }
        })
        .catch(err => {
          this.checkLoading = false;
          this.formLoading = false;
          this.formError = err.message;
          this.isFinish = false;
          this.deviceListSelectedAction(false);
        })
        .finally(() => {
          this.checkLoading = false;
        });
    },

    // 提交前检测
    checkSubmit() {
      this.checkDeviceStatus().then(status => {
        if (status) {
          // 参数
          let params = {};
          let selectedOption = this.plcOptions.find(option => option.value === this.form.plcType);
          if (selectedOption) {
            const optionParam1 = selectedOption.value;
            params = {
              ctrlId: this.form.ctrlId,
              devIds: this.deviceListSelected.map(item => item.key),
              params: [optionParam1, this.form.param2],
            };
            selectedOption = null;
          } else {
            params = {
              ctrlId: this.form.ctrlId,
              devIds: this.deviceListSelected.map(item => item.key),
              params: [this.form.param1, this.form.param2],
            };
          }

          this.isFinish = false;
          this.formLoading = true;

          // 禁用已选参数的删除
          this.deviceListSelectedAction(false);

          API.DeviceExecCommands(params)
            .then(res => {
              if (res.code === 0) {
                // 详细描述，用于获取多设备命令执行结果；注意：根据设备参数刷新状态判断, 0表示执行中(pending)，需要再次轮询获取结果；1表示命令执行完成(finish)
                // 注意：成功时，其data数据为：0：pending(正在执行状态，则前端需要轮询查询)；1：finish(完成状态，则前端不需轮询只查询)，2表示超时(timeout)则可以结束轮询要么提示用户要么重试。其他为错误码
                const data = res.data;
                if (data === 0 || data === 1) {
                  const self = this;
                  // 延迟3秒再拿结果
                  this.excuteTimer = setTimeout(function() {
                    self.getExcuteResult(params, self.currentControl);
                  }, 3 * 1000);
                } else {
                  // 2或者3
                  // 结束
                  this.$message.warning(this.$t('deivce_msg_exec_timeout'));
                  this.formLoading = false;
                  this.deviceListSelectedAction(true);
                }
              } else {
                // 报错
                this.formLoading = false;
                this.formError = res.message;
                this.deviceListSelectedAction(true);
              }
            })
            .catch(err => {
              // 报错
              this.formLoading = false;
              this.formError = err.message;
              this.deviceListSelectedAction(true);
            });
        }
      });
    },

    // 控制提交
    onControlSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          const _this = this;
          const h = this.$createElement;
          let contentHtml = [
            h('p', `${this.$t('device_control_type')}: ${this.currentControl.cmdName}`),
          ];

          let selectedOption = this.plcOptions.find(option => option.value === this.form.plcType);
          if (selectedOption) {
            const optionParam1 = selectedOption.label;
            // 选项参数1
            if (this.currentControl.param1 && optionParam1) {
              contentHtml.push(h('p', `${this.currentControl.param1}: ${optionParam1 || ''}`));
              selectedOption = null;
            }
          } else {
            // 参数1
            if (this.currentControl.param1 && _this.form.param1) {
              contentHtml.push(h('p', `${this.currentControl.param1}: ${_this.form.param1 || ''}`));
            }
          }

          // 参数2
          if (this.currentControl.param2 && _this.form.param2) {
            contentHtml.push(h('p', `${this.currentControl.param2}: ${_this.form.param2 || ''}`));
          }

          this.$confirm({
            title: this.$t('device_confirm_command_excute_title'),
            content: h('div', {}, contentHtml),
            centered: true,
            onOk: () => {
              this.checkSubmit();
            },
          });
        }
      });
    },

    // 获取执行结果
    getExcuteResult(params, currentControl) {
      const newParams = {
        devIds: params.devIds.join(','),
        protoEventType: currentControl.protoEventType,
      };

      this.clearExcuteTimer();

      API.DeviceExecCommandsResult(newParams).then(res => {
        if (res.code === 0 && res.data) {
          const ctrls = res.data.ctrls;
          if (ctrls) {
            // 多设备的时候，更新设备的状态即可(实际还是查询多设备各个参数的状态)
            ctrls.forEach(item => {
              // 循环设备
              this.deviceListSelected.forEach(device => {
                if (device.key === item.devId) {
                  device.ctrl = item;
                }
              });
            });
          }

          // 0表示执行中(pending)，需要再次轮询获取结果；1表示完成(finish)，设备命令执行完成;
          const execStatus = res.data.execStatus;
          // 是否轮询
          if (execStatus === 0) {
            const self = this;
            this.excuteTimer = setTimeout(function() {
              self.getExcuteResult(params, currentControl);
            }, 2 * 1000);
          } else if (execStatus === 1) {
            this.isFinish = true;
            this.formLoading = false;
            this.deviceListSelectedAction(true);
          } else {
            // error
            this.formLoading = false;
            this.formError = this.$t('device_msg_set_timeout');
            this.deviceListSelectedAction(true);
          }
        }
      });
    },

    // 重置表单
    close() {
      this.deviceListSelected = [];
      this.isFinish = false;
      this.formError = '';
      // this.$refs.formElement.resetFields();
      this.currentControl = null;
      this.form = {
        ctrlId: undefined,
        plcType: undefined,
        param1: undefined,
        param2: undefined,
      };

      this.clearExcuteTimer();

      this.visible = false;
    },

    selectDeviceConfirm() {
      // 操作设备后，取消错误显示
      this.formError = '';

      this.deviceList.some(item => {
        if (item.key === this.willbeSelected) {
          this.deviceListSelected.push(item);
          item.disabled = true;
          return true;
        }
        return false;
      });
      this.willbeSelected = undefined;
    },
    selectDeviceDelete(key) {
      // 操作设备后，取消错误显示
      this.formError = '';

      this.deviceListSelected.some((item, index) => {
        if (item.key === key) {
          this.deviceListSelected.splice(index, 1);
          return true;
        }
        return false;
      });
      this.deviceList.some(item => {
        if (item.key === key) {
          item.disabled = false;
          return true;
        }
        return false;
      });
    },

    // 选择FTP
    selectFTP() {
      this.attachmentVisible = true;
    },

    // 附件选择
    attachmentSelected(data) {
      this.form[this.ftpParams] = data;
      this.attachmentVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.device-control {
  padding-top: 5px;
  .device-control-selection {
    .device-box {
      padding: 0 15px;

      .device-box-title {
        font-size: 16px;
        font-weight: bold;
        padding: 6px 0 6px 0;
      }
      .device-box-content {
        padding: 10px;

        ::v-deep .device-selected {
          padding-top: 15px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .diabled {
            background: #ddd !important;
            border-color: #ddd !important;
          }

          .ant-tag {
            margin-bottom: 10px;
            padding: 5px;
            display: flex;
            align-items: center;
            font-size: 14px;

            > span {
              display: flex;
              align-items: center;
            }

            svg {
              margin: 0 0 0 5px;
            }
          }

          .anticon {
            color: #f00;
          }
        }

        .device-selected-action {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

::v-deep .device-control-list {
  padding: 0 20px 20px 20px;
  .ant-form-item-label {
    color: #999;
    label {
      color: #666;
    }
  }
}

.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

.device-control-param1 {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  button {
    margin-top: 2px;
    width: 50%;
  }
}
</style>
